<div #mapContainer class="map-container"></div>

<div [ngClass]="popup ? 'map-legend-popup' : 'map-legend'">
    <div class="map-legend-item">
        <div class="symbol-continer">
            <img [src]="markerUrl" width="20" height="22" style="margin-left: 15%;" />
        </div>
        <span>Centro de trabajo</span>
    </div>
    <div *ngIf="userMarkerCenter && userMarkerUrl" class="map-legend-item">
        <div class="symbol-continer">
            <img [src]="userMarkerUrl" width="20" height="20" />
        </div>
        <span>Ubicación del usuario</span>
    </div>
    <div class="map-legend-item">
        <div class="symbol-continer">
            <div class="circle-box"></div>
        </div>
        <span>Radio válido de marcaje (105m)</span>
    </div>
</div>